import { useEffect, useRef, useState } from "react";
import { Cookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import * as XLSX from 'xlsx';
import { ExportData } from "../../Exports/Export";
import Footer from "../../Layout/FooterComponent";
import CustodianMasterTable from './CustodianMasterTable';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, readFile } from "../../Common/Common";
import { ImportButton } from "../../Common/BulkUploadData";


const cookies = new Cookies();

const CustodianMasterForm = () => {
    const [edit, setEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false)
    const [tableData, setTableData] = useState([])
    const [ColoredRow, setColoredRow] = useState(null);
    const [EventCodeDropDown, setEventCodeDropdown] = useState([]);
    const [DistrictDropdown, setDistrictDropdown] = useState([])
    const navigate = useNavigate();
    const [ImportData, setImportData] = useState([]);
    const [Name, setName] = useState('');
    const [status, setStatus] = useState([]);
    const [SessionClear, SetSessionClear] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterList, setFilterList] = useState([]);
    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
    })
    const [formData, setFormData] = useState({
        CustodianMasterID: "",
        DistrictCode: "",
        CustodianCode: '',
        EventCode: '',
        CustodianName: '',
        IsActive: true
    });
    const inputRefs = useRef([]);

    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')
    const Source = 'web';

    const EventDropdownList = async () => {


        let data = { Token, LoginUserCode }
        await fetch('/api/MasterController/GetEvent',
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setEventCodeDropdown(res.eventList);
            }).catch((err) => console.log(err));

    };
    const getCustodianMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Source: 'web',
            Type: 'S',
            PageIndex: `${PageIndex}`
        }
        setLoading(true)
        await fetch('/api/MasterController/ShowCustodianMaster', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }
        ).then(async (response) => {
            let res = await response.json();
            if (res.status === 'SUCCESS') {
                setTableData(res)
                setLoading(false)
                inputRefs.current[res.focus].focus()
            }
            else if (res.message === "EXPIRED") {
                navigate("/login");
                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                toast.error(res.message, {

                });
                setTableData(res)
                setLoading(false)
            }
        }).catch((err) => {
            toast.error(err.message, {

            })
            setLoading(false)
        }, [filterData])
    }

    const handleChange1 = (event, value) => {
        getCustodianMasterData(value)
    };


    const handleClear = () => {
        setFormData({
            CustodianMasterID: "",
            DistrictCode: "",
            CustodianCode: '',
            EventCode: '',
            CustodianName: '',
            IsActive: true
        })
        filterData.SearchText = ''
        setColoredRow(null)
        setImportData([])
        setStatus([])
        BulkClearData()
        setEdit(false)
        getCustodianMasterData()
    }

    const handleSubmit = async () => {
        let data = {
            ...formData, Token, LoginUserCode, Source
        }
        setIsLoading(true)
        await fetch('/api/MasterController/InsertUpdateCustodianMaster', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json();
            if (res.status === "SUCCESS") {
                setIsLoading(false);
                toast.success(res.message, {

                })
                handleClear();
                setIsLoading(false)
                setEdit(false);
                setColoredRow(null)

            }
            else if (res.message === "EXPIRED") {
                navigate("/login");
                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                setIsLoading(false)
                toast.error(res.message, {

                })
                inputRefs.current[res.focus].focus()
                inputRefs.current[res.focus].children[0].children[0].focus()

            }
        }).catch((err) => {
            setIsLoading(false)
            toast.error(err, {

            })
        })
    };

    const handleEditData = async (id) => {
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: await cookies.get('loginUserCode'),
            Source: 'web',
            CustodianMasterID: id
        }
        await fetch(`/api/MasterController/EditCustodianMaster`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            await setEdit(true)
            let res = await response.json()
            if (res.status === 'SUCCESS') {
                setColoredRow(id)
                await setFormData({ ...formData, CustodianMasterID: id, CustodianCode: res.custodianCode, CustodianName: res.custodianName, EventCode: res.eventCode, DistrictCode: res.districtCode, IsActive: res.isActive });
                await DistrictDropdownList(res.eventCode)
                inputRefs.current[res.focus].focus()
            }
            else if (res.message === "EXPIRED") {
                navigate("/login");
                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                toast.error(res.message, {

                })
            }
        }).catch((err) => {
            toast.success(err, {

            })
        })
    }

    const getSearchingList = async () => {
        let data = {
            Token, LoginUserCode, PageName: 'CustodianMaster'
        }
        await fetch('/api/DashboardController/BindSearchingColumnList', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json()
            let list = res.getSearchingList
            setFilterData({ ...filterData, SearchFieldValue: list[0].searchingValue })
            setFilterList(res.getSearchingList)
        }).catch((err) => {
            toast.error(err, {

            })
        })
    };

    const downloadExcel = (records) => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([
            [records.hSrNo, records.hEventName, records.hDistrict, records.hCustodianCode, records.hCustodianName,
            records.hCreatedBy, records.hCreatedDate, records.hIsActive, records.hModifiedBy, records.hModifiedDate,]
            ,
            ...records.getCustodianMasterData?.map((records) => [records.srNo, records.eventCode, records.districtCode, records.custodianCode, records.custodianName,
            records.createdBy, records.createdDate, records.isActive, records.modifiedBy, records.modifiedDate,
            ]),
        ]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveExcelFile(excelBuffer, 'CustodianMaster.xlsx');
    };

    const saveExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadExcel = async () => {
        const apiUrl = `/api/MasterController/ShowCustodianMaster`;
        const requestBody = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Type: 'E',
            PageIndex: '1'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        const records = await ExportData(apiUrl, requestBody, requestHeaders);
        if (records) {
            downloadExcel(records);
        }
    };
    const DistrictDropdownList = async (event) => {
        let data = { Token, LoginUserCode, EventCode: event, Type: 'GetDistrict' }
        await fetch('/api/MasterController/GetVenue',
            {

                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json()
                setDistrictDropdown(res.district);

            }).catch((err) => console.log(err));

    };
    const DownloadFormat = async () => {
        await DownloadFileAtURL('CustodianMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(status, 'CustodianMasterError')
    };
    const BulkSubmit = async (e) => {
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        let a = document.querySelectorAll('.jRuVVs')
        if (a.length > 0) {
            a[0].innerHTML = data.FileName
        }
    };
    const handleBulk = async () => {
        let data = {
            Token, LoginUserCode, Source
        }
        if (ImportData.length !== 0) {

            if (true) {
                let Data = await HandleBulkInsertData('/api/MasterController/InsertUpdateCustodianMaster', ImportData, data, '', '')
                setStatus(Data)
                toast.info(`SUCCESS : ${Data.SuccessCount} Error : ${Data.ErrorCount}`)

            } else {
                toast.error('Header Format is not valid !', {
                    position: 'top-center'
                })

            }
        } else {
            toast.error('Please Choose File With Valid Data.!')

        }

    };
    useEffect(() => {
        getCustodianMasterData()
        getSearchingList()
        EventDropdownList()
        document.title = "CustodianMaster"

    }, [])

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Custodian Master'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area d-flex gap-2">
                                <div className="row align-items-end col-lg-8">

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Event <span className="Required">*</span></label>
                                            <select
                                                ref={ref => (inputRefs.current['ddlEventCode'] = ref)}
                                                id="inputState"
                                                className="form-select"
                                                value={formData.EventCode}
                                                onChange={(e) => {
                                                    setFormData({ ...formData, EventCode: e.target.value })
                                                    DistrictDropdownList(e.target.value)

                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['ddlDistrictCode'].focus()
                                                    };
                                                }}
                                            >
                                                <option value=''>Please Select Event </option>
                                                {
                                                    EventCodeDropDown?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.eventCode}>{item.eventName}</option>
                                                        )
                                                    })
                                                }
                                            </select>

                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">District <span className="Required">*</span></label>
                                            <select
                                                ref={ref => (inputRefs.current['ddlDistrictCode'] = ref)}
                                                id="inputState"
                                                className="form-select"

                                                value={formData.DistrictCode}
                                                onChange={(e) => setFormData({ ...formData, DistrictCode: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtCustodianCode'].focus()
                                                    };
                                                }}
                                            >
                                                <option value=''>Please Select District </option>
                                                {
                                                    DistrictDropdown?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.districtCode}>{item.districtName}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Custodian Code <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtCustodianCode'] = ref)}
                                                type="text"
                                                id="txtCustedianCode"
                                                className="form-control"
                                                placeholder="Custodian Code"
                                                autoComplete="off"

                                                maxLength='10'
                                                value={formData.CustodianCode}
                                                onChange={(e) => setFormData({ ...formData, CustodianCode: e.target.value })}

                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtCustodianName'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">  Custodian Name <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtCustodianName'] = ref)}
                                                type="text"
                                                className="form-control"
                                                placeholder="Custodian Name"
                                                autoComplete="off"
                                                maxLength='100'

                                                value={formData.CustodianName}
                                                onChange={(e) => setFormData({ ...formData, CustodianName: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['chkActive'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                ref={ref => (inputRefs.current['chkActive'] = ref)}
                                                className="form-check-input"
                                                type="checkbox"
                                                id="activeCheckbox"

                                                checked={formData.IsActive}
                                                onChange={(e) => setFormData({ ...formData, IsActive: e.target.checked })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit()
                                                    };
                                                }}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            {edit ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update & Save
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <ImportButton
                                    handleBulk={handleBulk}
                                    BulkSubmit={(e) => BulkSubmit(e)}
                                    downloadFormat={DownloadFormat}
                                    ErrorData={ErrorData}
                                    Status={status}
                                >
                                </ImportButton>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <CustodianMasterTable loading={isLoading} handleChange={handleChange1} handleReset={handleClear} setColoredRow={setColoredRow} ColoredRow={ColoredRow} currentPageNo={currentPageNo} filterList={filterList} filterData={filterData} setFilterData={setFilterData} tableData={tableData} getCustodianMasterData={getCustodianMasterData} handleEditData={handleEditData} />
            <ToastContainer theme='colored' />
            <Footer />
        </>
    )
}
export default CustodianMasterForm;